import { useCallback } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';

export const useSegmentPage = (
  analytics: AnalyticsBrowser,
  setEventsCalled: (events: string[]) => void
) => {
  return useCallback(
    (title: string) => {
      analytics.page(
        title,
        {
          nonInteraction: 1,
        },
        {
          consent: {
            categoryPreferences: {
              necessary: window.Cookiebot?.consent?.necessary,
              preferences: window.Cookiebot?.consent?.preferences,
              statistics: window.Cookiebot?.consent?.statistics,
              marketing: window.Cookiebot?.consent?.marketing,
            },
          },
        }
      );
      setEventsCalled([]);
    },
    [analytics]
  );
};
